import encryptedStorage from '@/stores/encryptedStorage';
import store from '@/stores/store';

export type Session = {
  startDate: number;
  endDate: number;
};

const storage = encryptedStorage();

/* eslint-disable no-unused-vars */
export function getStars(patientId: string) {
  return new Promise(async (res) => {
    let userId, container;
    if (patientId) {
      const key = `starContainer${patientId}`;
      const data = await storage.getItem(key);
      container = data;
    } else {
      userId = store.getState().signedInUser?.user?._id;
      container = store.getState().storedStars['starContainer' + userId];
    }
    if (!container) {
      return res(null);
    }
    const starData: Record<string, unknown> = {};
    const containerStore = container.store;
    const storeKeys = Object.keys(containerStore);
    storeKeys.forEach(function (key) {
      const value = containerStore[key].duration;
      let stars = msToStars(value);
      if (stars > 0) {
        starData[key] = stars;
      }
    });
    res(starData);
  });
}

function msToStars(ms: number) {
  let starTime = 1000 * 60 * 10;
  return Math.floor(ms / starTime);
}
